import { createTheme } from '@mui/material/styles'
import { green, grey, red } from '@mui/material/colors'

const rawTheme = createTheme({
    palette: {
        primary: {
            light: '#69696a',
            main: '#00797a',
        },
        secondary: {
            light: '#fff5f8',
            main: '#ff3366',

            dark: '#e62958',
        },
        warning: {
            main: '#ffc071',

            // dark: "#ffb25e",
        },
        error: {
            light: red[50],
            main: red[500],
            dark: red[700],
        },
        success: {
            light: green[50],
            main: green[500],
            dark: green[700],
        },
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Helvetica',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 700,
    },
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: '1', // increase opacity for disabled input
                        color: '#000',
                        WebkitTextFillColor: '#000',
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 1,
                        color: '#00000066',
                        WebkitTextFillColor: '#00000066',
                    },
                },
            },
        },
    },
})

const fontHeader = {
    // color: rawTheme.palette.text.primary,
    color: rawTheme.palette.primary.main,
    fontWeight: rawTheme.typography.fontWeightMedium,
    fontFamily: "'Roboto Condensed', sans-serif",

    // textTransform: "uppercase",
}

const theme = {
    ...rawTheme,
    palette: {
        ...rawTheme.palette,
        background: {
            ...rawTheme.palette.background,
            default: rawTheme.palette.common.white,
            placeholder: grey[200],
        },
    },
    typography: {
        ...rawTheme.typography,
        fontHeader,
        h1: {
            ...rawTheme.typography.h1,
            ...fontHeader,
            letterSpacing: 0,
            fontSize: 60,
        },
        h2: {
            ...rawTheme.typography.h2,
            ...fontHeader,
            fontSize: 48,
        },
        h3: {
            ...rawTheme.typography.h3,

            // ...fontHeader,
            fontWeight: rawTheme.typography.fontWeightMedium,
            fontSize: 24,
        },
        h4: {
            ...rawTheme.typography.h4,
            ...fontHeader,
            fontSize: 20,
        },
        h5: {
            ...rawTheme.typography.h5,
            fontSize: 18,
            fontWeight: rawTheme.typography.fontWeightMedium,
        },
        h6: {
            ...rawTheme.typography.h6,
            ...fontHeader,
            fontSize: 16,
        },
        subtitle1: {
            ...rawTheme.typography.subtitle1,
            fontSize: 16,
        },
        body1: {
            ...rawTheme.typography.body2,
            fontWeight: rawTheme.typography.fontWeightRegular,
            fontSize: 14,
        },
        body2: {
            ...rawTheme.typography.body1,
            fontSize: 12,
        },
        textHeader: {
            ...rawTheme.typography,
            fontSize: 14,
            fontWeight: rawTheme.typography.fontWeightLight,
        },
        button: {
            ...rawTheme.typography,
            fontSize: 14,
            fontWeight: 500,
        },
    },
    colorUbq: {
        color: rawTheme.palette.primary.main,
    },
    tableHeader: {
        color: '#5dd0df',
    },
    background: {
        color: '#f1fdff',
    },
    fontFamily: rawTheme.typography.fontFamily,
}

export default theme
